interface ContainerProps {
	className?: string
	children: React.ReactNode
	style?: React.CSSProperties
}

const Container = ({ className, children, style }: ContainerProps) => {
	// TODO: use tailwind instead of styles
	const styles = {
		container: {
			flex: 1, // fill layout height
			flexGrow: 1, // fill layout width
			maxWidth: '1280px'
		}
	}

	return (
		<div
			className={`${className} overflow-hidden px-4 pb-[100px] md:px-6 xl:px-10`}
			style={{ ...styles.container, ...style }}
		>
			{children}
		</div>
	)
}

export default Container
